module.exports = "<app-card-wrapper [removePanel]=\"true\" [active]=\"false\" [fullHeight]=\"true\">\n    <div\n         class=\"search-result-failure-card-container\">\n      <h4 translate>error.order.searchResult.shipment.title</h4>\n      <p translate>error.order.searchResult.shipment.message</p>\n    </div>\n</app-card-wrapper>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/consignment/search-results/components/search-result-card-failure/search-result-card-failure.component.html
// module id = ./src/app/modules/consignment/search-results/components/search-result-card-failure/search-result-card-failure.component.html
// module chunks = main